import { useState } from "react";
import classNames from "classnames";
import { isEmail } from "validator";
import { useRouter } from "next/router";
import Input from "./Input";
import config from "../../data/config";

const loadingClass = "opacity-50 cursor-not-allowed";

const buttonClass = classNames(
  "bg-blue rounded",
  "font-bold text-2xl text-white",
  "cursor-pointer outline-none focus:outline-none",
  "w-full md:w-auto px-8 h-16",
  "mt-6 md:mt-0"
);

function EmailForm({ email, setEmail, setShowOTPForm }) {
  const [emailValidationError, setEmailValidationError] = useState(null);
  const [loading, setLoading] = useState(false);
  function onSubmit(e) {
    e.preventDefault();
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, {
          action: "submit",
        })
        .then(function (token) {
          const emailValidationError = isEmail(email)
            ? null
            : "Not a valid email";
          setEmailValidationError(emailValidationError);
          if (emailValidationError) {
            return;
          }
          setLoading(true);
          fetch("/api/generate-otp", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, token }),
          })
            .then((response) => response.json())
            .then((data) => {
              setShowOTPForm(true);
            })
            .catch((error) => {
              console.error("Error:", error);
              setLoading(false);
            });
        });
    });
  }
  return (
    <form onSubmit={onSubmit}>
      <div className="block md:flex">
        <Input
          placeholder="Enter your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim())}
          error={emailValidationError}
        />
        <button
          className={classNames(buttonClass, {
            [loadingClass]: loading,
          })}
          type="submit"
          disabled={loading}
        >
          {loading ? "Registering" : "Register"}
        </button>
      </div>
    </form>
  );
}

function OTPForm({ email, otp, setOTP }) {
  const router = useRouter();
  const [otpValidationError, setOTPValidationError] = useState(null);
  const [loading, setLoading] = useState(false);
  function onSubmit(e) {
    e.preventDefault();
    const otpValidationError =
      otp && otp.trim().length === 6 ? null : "Not a valid OTP";
    setOTPValidationError(otpValidationError);
    if (otpValidationError) {
      return;
    }
    setLoading(true);
    fetch("/api/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, otp: otp.trim() }),
    })
      .then((response) => response.json())
      .then((data) => {
        // router.push(`/ticket-confirmation/${data.id}`);

        if (data.githubUserName) {
          router.push(`/ticket-confirmation/${data.id}`);
        } else {
          router.push(`/generate-ticket/${data.id}`);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
        setOTPValidationError("Email verification failed. Enter correct OTP.");
      });
  }
  return (
    <form onSubmit={onSubmit}>
      <p className="text-lg mb-2 text-center md:text-left">
        We&apos;ve sent an OTP to your Email
      </p>
      <div className="block md:flex">
        <Input
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOTP(e.target.value)}
          error={otpValidationError}
        />
        <button
          className={classNames(buttonClass, { [loadingClass]: loading })}
          type="submit"
          disabled={loading}
        >
          {loading ? "Verifying Email" : "Verify Email"}
        </button>
      </div>
    </form>
  );
}

export default function TicketRegisterForm() {
  const [email, setEmail] = useState("");
  const [otp, setOTP] = useState("");
  const [showOTPForm, setShowOTPForm] = useState(false);
  if (!config.ENABLE_REGISTRATION) {
    return <div className="text-2xl text-center">Registrations Closed</div>;
  }

  if (showOTPForm) {
    return <OTPForm email={email} otp={otp} setOTP={setOTP} />;
  }

  return (
    <EmailForm
      email={email}
      setEmail={setEmail}
      setShowOTPForm={setShowOTPForm}
    />
  );
}
